const record = {
  path: 'record',
  component: resolve => require(['../../../../pages/user/videoplay/record'], resolve)
}

export default record



// WEBPACK FOOTER //
// ./src/router/user/videoplay/record/index.js